module.exports = __webpack_public_path__ + "static/media/view3.f417bf39.jpg";